<p>debit-charge-cancel-dialog works!</p>
